module.exports = __webpack_public_path__ + "static/media/donbosco20.ab1276d3.jpg";